<template>
  <div class="flex flex-col gap-16 w-full">
    <TypographyH1 class="font-semibold">
      {{ $t('health_actions.scheduling.add_optional_doctors_subtitle') }}
    </TypographyH1>
    <DoctorSkeletonLoader v-if="isFetchingProviders" :hasRadioButton="true" />
    <div v-else-if="getListOfDoctors.length < 2">
      <NoDoctorsFound
        @open-zip-code-modal="openZipCodeModal"
        @close-zip-code-modal="closeZipCodeModal"
      />
    </div>
    <div v-else class="flex flex-col gap-16 w-full">
      <WarningBox
        class="self-start w-full sm:w-1/2"
        :text="$t('health_actions.scheduling.add_optional_doctors_description')"
        textClass="text-sm"
      />
      <TypographyBody class="font-semibold">
        {{ $t('health_actions.scheduling.select_doctor_recommended_doctors') }}
      </TypographyBody>
      <DoctorCardSelect
        v-for="doctor in doctorsNotYetSelected.slice(0, 3)"
        :key="doctor.name"
        :doctor="doctor"
        canSelectMultiple
      />
    </div>
  </div>
</template>

<script>
import TypographyH1 from '~/components/common/Typography/H1.vue'
import DoctorCardSelect from './DoctorCard/DoctorCardSelect.vue'
import WarningBox from './WarningBox.vue'
import { mapGetters } from 'vuex'
import TypographyBody from '~/components/common/Typography/Body.vue'
import NoDoctorsFound from './NoDoctorsFound.vue'
import DoctorSkeletonLoader from './DoctorSkeletonLoader.vue'
export default {
  components: {
    DoctorCardSelect,
    WarningBox,
    TypographyH1,
    TypographyBody,
    NoDoctorsFound,
    DoctorSkeletonLoader,
  },
  computed: {
    ...mapGetters('scheduling', [
      'getListOfDoctors',
      'selectedDoctors',
      'isFetchingProviders',
    ]),
    doctorsNotYetSelected() {
      return this.getListOfDoctors.filter(
        (doctor) => doctor.id !== this.selectedDoctors[0]?.id
      )
    },
  },
  methods: {
    openZipCodeModal() {
      this.$emit('open-zip-code-modal')
    },
    closeZipCodeModal() {
      this.$emit('close-zip-code-modal')
    },
  },
}
</script>
